export default __webpack_public_path__ + "static/media/rocket_anim_114.6271774a.png";